import { CheckCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { colors } from 'colors';
import { StepperProps } from 'common/types/types';
import { useUserProfileValidation } from 'hooks/query';
import { Icon, Stepper } from 'legacy-components/componets';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePenaltyPayments } from 'hooks/query/penalty/use-penalty-payments';

const WarningIcon = ({ title }: { title: string }) => {
  return (
    <Tooltip
      title={title}
      color={colors.white}
      mouseEnterDelay={0}
      arrow={false}
      overlayInnerStyle={{ color: colors.danger }}
    >
      <button>
        <Icon name={'danger'} height={24} width={24} />
      </button>
    </Tooltip>
  );
};

const LandlordProfileInfoStepper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, isLoading } = useUserProfileValidation({
    placeholderData: (previousValue) => previousValue,
  });
  const { data: penaltiesData } = usePenaltyPayments();
  const penalties = penaltiesData?.individualPenalties || [];
  const hasPenalties = penalties.length > 0;
  const unpaidPenalties = penalties.filter(penalty => !penalty.isPaid);

  const stepList = useMemo(() => {
    return [
      {
        id: 'personal',
        title: 'Personal',
        extra: isLoading ? null : data?.isProfileValid ? null : <WarningIcon title='Please, complete your profile' />,
      },
      {
        id: 'payment-details',
        title: 'Payment',
      },
      {
        id: 'payout-details',
        title: 'Payout',
      },
      data?.isIdentityEnabled && {
        id: 'verification',
        title: 'Verification',
        extra: isLoading ? null : data?.isIdentityValid ? (
          <CheckCircleFilled className={'text-lime-300 text-[24px]'} />
        ) : (
          <WarningIcon title='Please, verify your identity' />
        ),
      },
      hasPenalties && {
        id: 'penalties',
        title: 'Service Fees',
        extra: unpaidPenalties.length > 0 ? (
          <WarningIcon title={`You have ${unpaidPenalties.length} unpaid service fee${unpaidPenalties.length > 1 ? 's' : ''}`} />
        ) : (
          <CheckCircleFilled className={'text-lime-300 text-[24px]'} />
        ),
      },
    ].filter(Boolean) as StepperProps['steps'];
  }, [data, isLoading, hasPenalties, unpaidPenalties.length]);

  return (
    <Stepper
      className={'w-[180px]'}
      steps={stepList}
      activeItemId={location.pathname.split('/').slice(-1)[0]}
      onClick={(activeItemId) => {
        navigate(activeItemId);
      }}
    />
  );
};

export { LandlordProfileInfoStepper };
